/** Use prompt from an override only when it is a real string (not a click event). */
export function resolvePromptText(override, fallback = "") {
  const text = typeof override === "string" ? override : fallback;
  return String(text || "").trim();
}
